export default "/images/c0747863cad81aece1f9511351968340.avif";